/**
 * Configured SDK client for oRPC API v2
 *
 * Re-exports the auto-generated SDK client with proper baseUrl and auth headers.
 * Import SDK functions from './sdk' and they'll use this configured client automatically.
 *
 * Setup: call `setupSdkClient()` once during app initialization (after stores are ready).
 */
import { useUserStore } from '@/stores/user'
import { getSessionId } from '@/utils/session'

import { client } from './sdk/client.gen'

const API_BASE = import.meta.env.VITE_APP_PUBLIC_API_HTTP_URL + '/api/v2'

/**
 * Initialize the SDK client with baseUrl and auth interceptor.
 * Call this once in app setup (e.g., in main.ts or a plugin).
 */
export function setupSdkClient() {
  client.setConfig({ baseUrl: API_BASE })

  client.interceptors.request.use(request => {
    const userStore = useUserStore()
    const token = userStore.token

    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`)
    }

    request.headers.set('X-Session-ID', getSessionId())
    request.headers.set('X-Correlation-ID', crypto.randomUUID())

    return request
  })
}

export { client }
